// extracted by mini-css-extract-plugin
export var arrows = "_79-6";
export var decrementer = "_79-a";
export var disabled = "_79-4";
export var error = "_79-1";
export var hiddenText = "_79-b";
export var incrementer = "_79-9";
export var input = "_79-8";
export var inputWrapper = "_79-0";
export var leadingIcon = "_79-c";
export var readonly = "_79-3";
export var regular = "_79-7";
export var small = "_79-5";
export var warning = "_79-2";